// Visit-count-driven wordmark mechanic.
// Each visit cycles to a new typeface. After the 100th visit, the wordmark
// transforms into an outline of the KISUBIKA tote bag.
//
// All fonts are free Google Fonts so we can load them on demand without
// a license. We curate exactly 100 distinct families to mark the journey.

export const WORDMARK_FONTS = [
  // 01–20 — Modern grotesque & geometric sans
  "Hanken Grotesk", "Space Grotesk", "Manrope", "Inter", "DM Sans",
  "Outfit", "Plus Jakarta Sans", "Albert Sans", "Sora", "Lexend",
  "Public Sans", "Work Sans", "Archivo", "Be Vietnam Pro", "Onest",
  "Mona Sans", "Geist", "Wix Madefor Display", "Figtree", "Urbanist",
  // 21–40 — Display & condensed
  "Anton", "Bebas Neue", "Oswald", "Archivo Black", "Big Shoulders Display",
  "Black Ops One", "Bungee", "Holtwood One SC", "Major Mono Display", "Monoton",
  "Rubik Mono One", "Faster One", "Bowlby One", "Black Han Sans", "Frijole",
  "Rye", "Sancreek", "Bungee Shade", "Ribeye Marrow", "Special Elite",
  // 41–55 — Editorial serif
  "Playfair Display", "DM Serif Display", "Bodoni Moda", "Cormorant Garamond", "Lora",
  "EB Garamond", "Libre Caslon Display", "Crimson Pro", "Vollkorn", "Spectral",
  "Tinos", "Cardo", "IM Fell English", "Sorts Mill Goudy", "Aboreto",
  // 56–70 — Slab, mono & utility
  "JetBrains Mono", "IBM Plex Mono", "Space Mono", "VT323", "Courier Prime",
  "Roboto Mono", "Fira Code", "Inconsolata", "Cutive Mono", "Anonymous Pro",
  "Bree Serif", "Roboto Slab", "Zilla Slab", "Bevan", "Fraunces",
  // 71–85 — Script & expressive
  "Caveat", "Pacifico", "Lobster", "Italianno", "Great Vibes",
  "Bonheur Royale", "Marck Script", "Sacramento", "Yellowtail", "Allura",
  "Permanent Marker", "Indie Flower", "Reenie Beanie", "Homemade Apples", "Kalam",
  // 86–99 — Wildcards
  "Press Start 2P", "Silkscreen", "Honk", "Rampart One", "Goblin One",
  "Tilt Prism", "Tilt Warp", "Climate Crisis", "Geostar", "Codystar",
  "Audiowide", "Megrim", "Stalinist One", "Nabla",
];

export const TOTAL_FONTS = WORDMARK_FONTS.length; // 99
export const BAG_OUTLINE_VISIT = 100;

const STORAGE_KEY = "kisubika_visits";

const readVisits = () => {
  try {
    const v = parseInt(localStorage.getItem(STORAGE_KEY) || "0", 10);
    return Number.isFinite(v) && v >= 0 ? v : 0;
  } catch {
    return 0;
  }
};

const writeVisits = (n) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(n));
  } catch {
    /* private mode */
  }
};

/** Increment the visit counter once per page-mount and return the new value. */
export const bumpVisits = () => {
  const v = readVisits() + 1;
  writeVisits(v);
  return v;
};

export const getVisits = readVisits;

export const fontForVisit = (visit) => {
  if (visit >= BAG_OUTLINE_VISIT) return null; // → render outline
  // visit is 1-indexed; cycle through fonts deterministically
  const idx = ((visit - 1) % TOTAL_FONTS + TOTAL_FONTS) % TOTAL_FONTS;
  return WORDMARK_FONTS[idx];
};

/** Inject (once per family) a Google Fonts <link> for the requested family. */
const loadedFamilies = new Set();
export const loadFontFamily = (family) => {
  if (!family || loadedFamilies.has(family)) return;
  loadedFamilies.add(family);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
    family
  )}:wght@400;500;600;700;800;900&display=swap`;
  link.dataset.kbWordmark = "1";
  document.head.appendChild(link);
};
